import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const CREST = { color: "/brand/gprtu-crest.png", white: "/brand/gprtu-crest-white.png", navy: "/brand/gprtu-crest-navy.png" };
export const NAVY = "#182678";

export const Crest = ({ variant = "color", className = "h-10 w-10", testid }) => (
  <img src={CREST[variant]} alt="GPRTU crest - Ghana Private Road Transport Union of T.U.C." className={`${className} select-none object-contain`} draggable={false} data-testid={testid} />
);

export const FlagStrip = ({ className = "h-1" }) => (
  <div className={`flex w-full ${className}`} aria-hidden="true">
    <span className="flex-1 bg-[#CE1126]" /><span className="flex-1 bg-[#FCD116]" /><span className="flex-1 bg-[#006B3F]" />
  </div>
);

export function BrandLockup({ sub = "Intercity Ticketing", subClass = "text-[#0284C7]", managed = false, to = "/" }) {
  return (
    <Link to={to} className="group flex items-center gap-2.5" data-testid="header-logo-link">
      <span className="grid h-11 w-11 place-items-center rounded-full bg-white ring-1 ring-slate-200 transition-transform duration-300 group-hover:rotate-[-6deg]">
        <Crest className="h-10 w-10" testid="gprtu-header-logo" />
      </span>
      <span className="leading-none">
        <span className="block font-display text-lg font-extrabold tracking-tight" style={{ color: NAVY }}>GPRTU</span>
        <span className={`block text-[10px] font-bold uppercase tracking-[0.2em] ${subClass}`} data-testid="header-logo-sub">{sub}</span>
      </span>
      {managed && (
        <span className="ml-2 hidden border-l border-slate-200 pl-3 text-[10px] font-semibold uppercase leading-tight tracking-[0.14em] text-slate-400 lg:block" data-testid="header-managed-by">
          Developed by<br /><span className="text-slate-600">Nacasky Co. Ltd</span>
        </span>
      )}
    </Link>
  );
}

export function QuickRideLockup({ to = "/" }) {
  return (
    <Link to={to} className="flex items-center gap-3" data-testid="header-logo-link">
      <span className="flex items-center rounded-xl bg-[#0E1A5C] px-3 py-1.5 shadow-sm ring-1 ring-black/5">
        <img src="/brand/quickride-logo.png" alt="Quick Ride GH — official GPRTU ticket booking" className="h-7 w-auto" data-testid="quickride-logo" />
      </span>
      <span className="hidden leading-tight sm:block">
        <span className="block text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">Official GPRTU</span>
        <span className="block text-[11px] font-semibold text-slate-500">Ticket booking</span>
      </span>
    </Link>
  );
}

export const OfficialBadge = ({ dark = false }) => (
  <span className={`chip border ${dark ? "border-white/25 bg-white/10 text-white" : "border-[#C7D2FE] bg-white text-[#182678]"}`} data-testid="official-platform-badge">
    <ShieldCheck className="h-3.5 w-3.5" /> Official GPRTU ticketing
  </span>
);

// Letterhead for A4 documents (tickets, manifests, slips)
export function PrintBrand({ title, right }) {
  return (
    <div className="flex items-center justify-between gap-4 border-b-2 pb-3" style={{ borderColor: NAVY }}>
      <div className="flex items-center gap-3">
        <Crest className="h-14 w-14" />
        <div className="leading-tight">
          <div className="text-[10px] font-bold uppercase tracking-[0.16em]" style={{ color: NAVY }}>Ghana Private Road Transport Union of T.U.C.</div>
          <div className="font-display text-xl font-extrabold" style={{ color: NAVY }}>{title}</div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-500">United We Stand · Developed by Nacasky Co. Ltd</div>
        </div>
      </div>
      {right}
    </div>
  );
}

export const ThermalBrand = ({ title }) => (
  <div className="center">
    <img src={CREST.navy} alt="GPRTU" style={{ width: 64, height: 64, margin: "0 auto 4px", filter: "grayscale(1) brightness(0)" }} />
    <div className="big">GPRTU INTERCITY</div>
    {title && <div className="big">{title}</div>}
    <div>Developed by Nacasky Co. Ltd</div>
  </div>
);
